export const TERRAIN_CLEANUP_GENERATING_STRINGS = {
  TITLE: 'Generating Cleanup',
  DESCRIPTION:
    'Cleanup is being generated and will be set as the active terrain once complete. Changes will reflect automatically after refreshing the tab.',
  OPEN_ITERATIONS_BUTTON: 'Open Iterations Page',
  GENERATE_NEW_BUTTON: 'Generate New Cleanup',
};
